import { gql } from '@apollo/client';

export function townshipsQuery({ regionId }) {
  const name = `TownshipsQuery_${regionId}`;
  return gql`
    query ${name}($regionId: ID!) {
      townships(regionId: $regionId) {
        id
        name
        latitude
        longitude
      }
    }
  `;
}

const temp = 'just for eslint';

export default temp;
